export default __webpack_public_path__ + "static/ocpOesmv-e5f36f6c9365ddf461d59a78c8b38e90.svg";